// extracted by mini-css-extract-plugin
export default {"formatted-prize-matches":"FormattedPrizeMatches_formatted-prize-matches_Jxdcmb6s7Q8pj8wB23Mz","match":"FormattedPrizeMatches_match_jBhSWYlaYgRfs8WZYvkG"};